import * as React from 'react';
import NavHelper from '../components/NavHelper';

class Blog extends React.PureComponent {
  render(): JSX.Element {
    return (
      <div>
        <NavHelper pageName="Blog" icon="fa-newspaper-o" />
        <section id="main-content" className="main-content pad-60">
          <div className="container">
            <div className="row">
              {/* page content start */}
              <div className="col-md-8">
                <div id="primary" className="content-area">
                  <main id="main" className="site-main" role="main">
                    <article id="post-1" className="post-class">
                      <header className="entry-header">
                        <div className="post-thumbnail">
                          <img src="assets/images/blog/1.jpg" alt="blog-post" />
                          <div className="thumb-hover">
                            <div className="thumb-icon">
                              <a href="assets/images/blog/1.jpg" className="fancybox"><i className="fa fa-search-plus" /></a>
                            </div>
                          </div>
                        </div>
                        <h2 className="article-title"><a href="blog-single.html">Gender-based violence in Timor-Leste</a></h2>
                      </header> {/* /.entry-header */}
                      <div className="entry-meta">
                        <span className="date">
                          <i className="fa fa-clock-o" /> Oct 15 2014
                      </span> {/*/.date*/}
                        <span className="author">
                          <i className="fa fa-user" />
                          <a href="#">Super user</a>
                        </span> {/*/.author*/}
                        <span className="category">
                          <i className="fa fa-file" /> Blog
                      </span> {/*/.category*/}
                        <span className="tags">
                          <i className="fa fa-user" />
                          <a href="#">Women</a>,
                        <a href="#">Elderly</a>
                        </span> {/*/.category*/}
                        <span className="comments">
                          <i className="fa fa-comment-o" />
                          <a href="#">0 Comments</a>
                        </span> {/*/.category*/}
                      </div> {/* /.entry-meta */}
                      <div className="entry-content">
                        <p>Violence against women and girls in Timor-Leste is widespread and is one of the biggest challenges that this young nation faces. It crosses the country’s income, culture and class divisions. A total of 59% of women between the ages of 15 and 49 who have been in a relationship have suffered from physical or sexual violence from a male intimate partner, according to the 2016 Nabilan Baseline Study by The Asia Foundation.</p>
                        <p>In addition to intimate partner violence, the report found that 14% of all women between 15–49 years old had been raped by a non-partner in their lifetime. This non-partner sexual violence is most likely perpetrated by family members, strangers, and men from the neighborhood, according to the Nabilan study.</p>
                        <p>Social acceptance and tolerance of gender-based violence is high in Timor-Leste. According to the Demographic and Health Survey (2009–2010), 86% of women and 81% of men believe that it is justifiable for a husband to hit his wife under certain circumstances. Only 3% of women who sought help after suffering from domestic violence reported it to the police. Two out of three women who suffer from domestic violence do not tell anyone at all.</p>
                        <p>Despite the political gains, however, life for many - and especially that of women and girls - is both disadvantaged and precarious. Raised for the most part to be obedient and have little to no voice in terms of their own future and rights, Timorese girls are quite often subjugated in general by society at all levels and not least in terms of their sexual and reproductive health.
                        </p>
                        <p>“Our culture is very patriarchal and very traditional, so women and girls do not have power to make decisions for their own selves. For their health, for their body, their participation, their voice, their education. As well, even though some sexuality education curriculum is there in schools, often the teacher is not confident to deliver the information, and it is not something they feel comfortable to talk about. They feel they cannot introduce these ideas to children, it is only for those who are married. They tell me, when they get to this topic, they rip the pages of the textbook out” says Lala Soares, Women and Girls Empowerment Program Manager for Plan International in Timor-
</p>
                        <p>In seeking to address these challenges, the government of Timor-Leste has recently approved the Inclusive Education Policy, a groundbreaking move which outlines several key plans to sensitize the educational community, promote the rights of pregnant teenagers, and make aware to the girls, and their families, the advantages of continuing education.
</p>
                        <p>With just 20 per cent of all women in Timor-Leste participating in the workforce, the situation can only be described as critical, and the numbers of teenage pregnancy and early marriage will only increase.
</p>
                      </div> {/* /.entry-content */}
                      <footer className="entry-footer" />
                    </article> {/*//post1*/}
                  </main>
                </div>
              </div></div></div></section>
      </div>);
  }
}

export default Blog;



// WEBPACK FOOTER //
// ./src/page/Blog.tsx